<template>
	<div id="paids" class="paids">
        <vue-snotify></vue-snotify>
        <nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromPayments" @change="getPaymentsLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToPayments" @change="getPaymentsLocal(1)">
				<input class="form-control form-control-sm mr-sm-1" type="search" placeholder="Buscar" aria-label="Buscar" ref="searchPayments"
					v-model="searchPayments"
					v-on:keyup.enter="getPaymentsLocal(1)"
					@focus="$event.target.select()">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getPaymentsLocal(1)">Buscar</button>
				<div class="float-right d-none d-sm-inline separator"></div>
			</div>
			<div class="form-inline">
				<span class="mr-sm-1">Mostrar</span>
				<select class="form-control form-control-sm mr-sm-1 float-sm-right margin-right5 " id="qrows" v-model="qRowsPayment" @change="changeQRowsPayment">
					<option>5</option>
					<option>10</option>
					<option>25</option>
					<option>50</option>
					<option>100</option>
					<option>200</option>
					<option>1000</option>
			    </select>
			</div>
		</nav>

		<table class="table table-sm table-striped">
			<thead>
				<tr>
					<th v-for="(item, index) in headerListPayment" :key="index" :class="item.class">
						{{item.title}}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listPayments" :key="index">
					<td class="text-center">{{item.id}}</td>
					<td>{{item.typePayment}}</td>
					<td class="text-right">{{methodFormatNumber(item.amount)}}</td>
					<td class="text-center">{{item.bank}}</td>
					<td class="text-center">{{item.code}}</td>
					<td>{{item.description}}</td>
					<td class="text-center">
						<input type="date" v-model="item.transaction_date" @change="updatePaymentLocal(item.id, 'transaction_date', item.transaction_date)" :readonly="!(item.status_id == 38)"
							class="text-center" style="background: transparent">
					</td>
					<td class="text-center" :class="'b1g-' + item.color">
						<span class="badge" :class="'badge-' + item.color" v-if="item.status_id == 39 || item.status_id == 40">{{item.status}}</span>
						<div class="dropdown" v-else>
							<a class="btn btn-sm dropdown-toggle" :class="'btn-' + item.color" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								{{item.status}}
							</a>
							<div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
								<a class="dropdown-item" href="#" @click="updateStatusLocal(item.id, 39)">Confirmar</a>
								<a class="dropdown-item" href="#" @click="updateStatusLocal(item.id, 40)">Rechazar</a>
							</div>
						</div>
					</td>
					<td class="text-center">
						<span class="pointer"
							@click="showUploadDocumentModalComponentLocalAnalize(item)">{{setSourceLink(item.source)}}</span>
					</td>
				</tr>
			</tbody>
		</table>

		<pagination :pagination="paginationPayments" @getAllList="getAllPayments"></pagination>

		<upload-document-modal-component
			ref="uploadDocumentModalComponent" :controller="controller" configUploadDocumentId="1" :id="id" :btnDelete="false" :btnUpload="false"></upload-document-modal-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import payment from '@/mixins/generals/payment.js'

import Pagination from '@/components/Pagination.vue'
import UploadDocumentModalComponent from '@/components/UploadDocumentModalComponent.vue'

export default {
	name: 'Paids',
	mixins: [axiosAction, errors, mixin, payment],
	data() {
		return {
			id: 0,
			controller: 'order',
			headerListPayment: [
				{ title: 'ID', name: 'id', field: 'id', class: 'text-center' },
				{ title: 'Forma de Pago', name: 'id', field: 'id', class: 'text-center' },
				{ title: 'Monto', name: 'amount', field: 'amount', class: 'text-center' },
				{ title: 'Banco', name: 'bank', field: 'bank', class: 'text-center' },
				{ title: 'Codigo', name: 'code', field: 'code', class: 'text-center' },
				{ title: 'Descripción', name: 'description', field: 'description', class: 'text-center' },
				{ title: 'Fecha', name: 'date', field: 'date', class: 'text-center' },
				{ title: 'Estado', name: 'status', field: 'status', class: 'text-center' },
				{ title: 'Origen', name: 'source', field: 'source', class: 'text-center' },
			]
		}
	},
	computed: {
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Pagos')
			this.setSubTitleModule('')
			this.setPaymentInit()
		},
		changeQRowsPaymentLocal() {
			this.getPaymentsLocal(1)
		},
		getAllPaymentsResultLocal (response) {
		},
		getPaymentsLocal(page) {
			this.getAllPayments(page)
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'analyzeSourceResult': this.analyzeSourceResult(response); break;
				case 'getAllPaymentsResult': this.getAllPaymentsResult(response); break;
				case 'updatePaymentResult': this.updatePaymentResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		setPaymentInitLocal(){
			this.getPaymentsLocal(1)
		},
		setSourceLink(source) {
			if(source.type == 'order') {
				if(source.data.length == 1) {
					return source.data[0].typeOrder.name + ' (' + source.data[0].id + ')'
				}
			}
			if(source.type == 'consignment') {
				if(source.data.length == 1) 
					return 'Remesa (' + source.data[0].id + ')'
			}
			return source.length
		},
		showUploadDocumentModalComponentLocalAnalize(item) {
			console.log(item)
			if(item.upload_documents.length > 0) {
				this.controller = 'payment'
				this.showUploadDocumentModalComponentLocal(item.id)
			} else if(item.source.data.length == 1 && item.source.type != 'consignment') {
				this.controller = item.source.type
				this.showUploadDocumentModalComponentLocal(item.source.data[0].id)
			}			
		},
		showUploadDocumentModalComponentLocal(id) {
			this.id = id
			this.$refs.uploadDocumentModalComponent.$refs.showUploadDocument.click()
			setTimeout(() => {
				this.$refs.uploadDocumentModalComponent.$refs.btnGetUploadDocument.click()
			}, 10)
		},
		updateStatusLocal(id, statusId) {
			this.updatePayment(id, 'status_id', statusId)
		},
		updatePaymentResultLocal (response) {
			if(response.data.success === true) {
				this.$emit('showLockScreen', 'Analizando acciones por la actualización . . .')
				let url = this.apiBackend + 'payment/analyzeSource'
				this.axiosActionIS(url, 'POST', 'analyzeSourceResult', response.data.data.source.data)
			}
		},
		analyzeSourceResult(response) {
			if(response.data.success === true) {
				Object.entries(response.data.data).forEach(([key, value]) => {
					if(value.model == 'Order') {
						this.socketEmit(['UPDATE_ORDER_' + value.data.id], value.data)
						this.socketEmit(['UPDATE_ORDER'], value.data)
					}
				})
			}
		},
		updatePaymentLocal(id, field, value) {
			this.updatePayment(id, field, value)
		},
		updateTableGeneralResultLocal(response) {

		}
	},
	components: {
		'pagination': Pagination,
		'upload-document-modal-component': UploadDocumentModalComponent,
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>